import React, { useEffect, useState } from "react";
import axios from "axios";
import { Cake } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const tq = () => { const t = new URLSearchParams(window.location.search).get("t") || localStorage.getItem("kl_tenant"); return t ? { headers: { "X-Tenant": t } } : {}; };

// Suggerimento compleanno: se email/telefono coincidono con un cliente del circuito con data di nascita → "Compleanno il 12 giugno" (solo giorno e mese)
export default function BirthdayHint({ email, phone, deliverAt, onPick, testid = "giftcard-birthday-hint" }) {
  const [hint, setHint] = useState(null);
  useEffect(() => {
    const e = (email || "").trim(), p = (phone || "").trim();
    if (!(e.includes("@") && e.length > 5) && p.replace(/\D/g, "").length < 9) { setHint(null); return; }
    const t = setTimeout(() => {
      axios.post(`${API}/public/gift-cards/birthday-hint`, { email: e || null, phone: p || null }, tq()).then(({ data }) => setHint(data.found ? data : null)).catch(() => setHint(null));
    }, 500);
    return () => clearTimeout(t);
  }, [email, phone]);
  if (!hint) return null;
  const picked = deliverAt && deliverAt.slice(0, 10) === hint.deliver_at.slice(0, 10);
  return (
    <button type="button" onClick={() => onPick(hint.deliver_at)} className={`w-full text-left rounded-xl px-3 py-2 text-sm flex items-center gap-2 ring-1 transition ${picked ? "bg-rose-600 text-white ring-rose-600" : "bg-rose-50 text-rose-800 ring-rose-200 hover:bg-rose-100"}`} data-testid={testid}>
      <Cake className="h-4 w-4 shrink-0" />
      <span>{picked ? <>Consegna fissata per il compleanno: <b>{hint.label}</b> alle 9:00</> : <>🎂 Il destinatario compie gli anni il <b>{hint.label}</b> — consegnala quel giorno alle 9:00?</>}</span>
    </button>
  );
}
